// Centralized OG Image configuration for each page
// All images are 1200x630 for optimal social sharing

import ogHome from '@/assets/og-home.jpg';
import ogMethod from '@/assets/og-method.jpg';
import ogAbout from '@/assets/og-about.jpg';
import ogPodcast from '@/assets/og-podcast.jpg';
import ogSpeaking from '@/assets/og-speaking.jpg';
import ogContact from '@/assets/og-contact.jpg';
import ogBlog from '@/assets/og-blog.jpg';

// Default fallback image (also used for homepage)
export const DEFAULT_OG_IMAGE = ogHome;

// Page-specific OG images configuration
export const OG_IMAGES = {
  // Homepage - general branding
  home: ogHome,
  
  // Method/System page - 6 pillars visualization
  method: ogMethod,
  
  // About page - Jürgen Klanert portrait
  about: ogAbout,
  
  // Podcast page - podcast cover
  podcast: ogPodcast,
  
  // Speaking page - keynote/stage image
  speaking: ogSpeaking,
  
  // Contact page - contact visual
  contact: ogContact,
  
  // Blog overview
  blog: ogBlog,
} as const;

export type OGPageKey = keyof typeof OG_IMAGES;

export const getOGImage = (page: OGPageKey): string => {
  return OG_IMAGES[page] || DEFAULT_OG_IMAGE;
};

// ---- Auto-generated OG images for blog articles ----
const OG_FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/og-image`;
const SITE_URL = 'https://www.klanert.com';

const absolutize = (url: string): string =>
  /^https?:\/\//i.test(url) ? url : `${SITE_URL}${url.startsWith('/') ? '' : '/'}${url}`;

/**
 * Returns the best OG image for an article: the featured image if present,
 * otherwise an automatically rendered branded 1200x630 cover.
 */
export const getArticleOGImage = (article: {
  title: string;
  category?: string | null;
  author?: string | null;
  featuredImage?: string | null;
}): string => {
  if (article.featuredImage) return absolutize(article.featuredImage);
  const params = new URLSearchParams({ title: article.title });
  if (article.category) params.set('category', article.category);
  if (article.author) params.set('author', article.author);
  return `${OG_FUNCTION_URL}?${params.toString()}`;
};
